/**
 * Meter types the "create meters" gestures offer (spec 2026-10-02-06): the
 * create-building wizard's step 2 and the equipment tab's *Add meters* dialog.
 * The codes are asset types inheriting `trade_metering`; the backend's
 * `POST /assets/{uid}/meters/provision` is idempotent, so offering a type that
 * already exists on an asset is harmless.
 *
 * `buildingDefault` is what the wizard pre-checks for a new building: the two
 * general meters almost every building has.
 */
export const METER_CHOICES = [
  { code: 'meter_electricity', buildingDefault: true, lotDefault: true },
  { code: 'meter_water_cold', buildingDefault: true, lotDefault: true },
  { code: 'meter_water_hot', buildingDefault: false, lotDefault: false },
  { code: 'meter_gas', buildingDefault: false, lotDefault: false },
  { code: 'meter_thermal_energy', buildingDefault: false, lotDefault: false },
] as const

export type MeterTypeCode = (typeof METER_CHOICES)[number]['code']

export type MeterTargets = 'self' | 'units' | 'self_and_units'
